export default __webpack_public_path__ + "static/logo-marshall-008ad5ba0e3998538305c6e5706ae30a.svg";